<app-dialog [dialogWithInput]="dialog">
    <app-document-sign #signComponent
                       (signedEvent)="signed()"
                       [displaySignButton]="false" [displayDownloadButton]="false" [documentId]="dialog.input.documentId"></app-document-sign>

    <app-button *ngIf="signComponent" dialog-actions fill="solid" color="primary"
                [disabled]="!signComponent.formGroup.valid || (signComponent.documentTemplateFindOneByIdService.loading$ | async)"
                (clickEvent)="signComponent.sign()"
                [loading]="(signComponent.documentSignService.loading$ | async) || (signComponent.documentTemplateSignService.loading$ | async)"
                label="Signer" iconName="signature"></app-button>
</app-dialog>
